var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-stretch"},[_c('NuxtLink',{attrs:{"to":_vm.localePath({
        name: 'professionalRatingPage',
        params: {
          professionalSeoName: _vm.person.seoName,
        },
      })},scopedSlots:_vm._u([{key:"default",fn:function({ navigate }){return [_c('b-button',{attrs:{"type":"is-info","outlined":""},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.$t("profileAction.rateMate"))+" ")])]}}])}),_c('div',{staticClass:"profile-report"},[_c('a',{staticClass:"text-xs",on:{"click":_vm.reportPerson}},[_vm._v(" "+_vm._s(_vm.$t("profileAction.reportMate"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }